import {connect} from 'react-redux';
import {PipetteVolume as Component} from './PipetteVolume';
import {
  showModal,
  setVol,
  incVol,
  decVol
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {
  return {
    id: ownProps.id,
    type: state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.id-1].type,
    volume: state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.id-1].volume,
    minVol: state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.id-1].minVol,
    maxVol: state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.id-1].maxVol,
    volChange: state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.id-1].volChange
  }
}

function mapDispatchToProps(dispatch) {
  return {
    showModal: (data) => {
      dispatch(showModal(data))
    },
    setVol: (data) => {
      dispatch(setVol(data))
    },
    incVol: (data) => {
      dispatch(incVol(data))
    },
    decVol: (data) => {
      dispatch(decVol(data))
    }
  };
}

export const PipetteVolume = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
